import { net } from "../../../../../../database";

/**
 * Process a payment for a customer, validating bill dates and posting to the API.
 * On success, sets the receipt state which triggers the receipt view.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 *
 * @param {string} customerId - The customer ID
 * @param {Object} payment - Payment object with students, excludedBills, etc.
 * @param {Function} setPayment - State setter for payment
 * @param {Function} setReceipt - State setter for receipt (set on success)
 * @param {Function} setDisabled - State setter for disabled button state
 */
export default function makePayment(
  customerId,
  payment,
  setPayment,
  setReceipt,
  setDisabled
) {
  let error = false;
  payment.students.forEach((student) => {
    if (student.nextBillDate === "") {
      student.billDateError = true;
      error = true;
    } else {
      student.billDateError = undefined;
    }
  });

  if (error) {
    setPayment({ ...payment });
    return;
  }

  setDisabled(true);

  net.post(`/customers/${customerId}/payments/add`, payment)
    .then((result) => {
      setReceipt(result.receipt);
      setDisabled(false);
    })
    .catch((err) => {
      console.error("Payment failed:", err);
      setDisabled(false);
    });
}